export enum TimeMode {
  now = 'now',
  arrival = 'arrival',
  departure = 'departure',
}
